// 1 = NUEVO - EN ESPERA PARA ENVIAR
// 2 = EN PROCESO -
// 3 = ENVIADO - ENVIADO A DESTINO
// 4 = ENTREGADO
// 5 = CANCELADO
// 6 = CUPON TEMPORAL ENTREGADO - DISPONIBLE PARA RETIRO
// 7 = CUPON TEMPORAL USADO - RETIRADO

import textServices from 'services/text-services'

const Status = ({ status }: { status: any }) => {
  const statusStyles = [
    {
      class: 'status-pending-send',
      text: textServices.findByText('', { es: 'En espera para enviar', en: 'Pending to send' })
    },
    {
      class: 'status-pending-pickup',
      text: textServices.findByText('', { es: 'En espera para retiro', en: 'Pending for pickup' })
    },
    {
      class: 'status-sent',
      text: textServices.findByText('', { es: 'Enviado a destino', en: 'Sent to destination' })
    },
    {
      class: 'status-available-pickup',
      text: textServices.findByText('', { es: 'Disponible para retiro', en: 'Available for pickup' })
    },
    {
      class: 'status-cancelled',
      text: textServices.findByText('', { es: 'Cancelado', en: 'Cancelled' })
    },
    {
      class: 'status-delivered',
      text: textServices.findByText('', { es: 'Entregado', en: 'Delivered' })
    },
    {
      class: 'status-withdrawn',
      text: textServices.findByText('', { es: 'Retirado', en: 'Withdrawn' })
    }
  ]

  const statusInfo = statusStyles[status - 1]

  return (
    <div className={`profile__history__status ${statusInfo?.class}`}>
      <p>{statusInfo?.text}</p>
    </div>
  )
}

export default Status
